import { utilities } from "../../styles";
import styles from "./AppPage.module.css";
import RecordTop from "../../assets/background/Record_Top.png";
import RecordBottom from "../../assets/background/Record_Bottom.png";

function AppPage(props: {
  children: React.ReactNode;
  bottomBar?: React.ReactNode;
  style?: React.CSSProperties;
  className?: string;
}) {
  const { children, bottomBar, style, className } = props;
  return (
    <div
      className={`${styles["app-page"]} ${utilities["flex-center"]}`}
      style={style}
    >
      <img
        className={`${styles["bg-record"]} ${styles["bg-record-top-left"]}`}
        src={RecordTop}
        alt=""
      />
      <img
        className={`${styles["bg-record"]} ${styles["bg-record-bottom-right"]}`}
        src={RecordBottom}
        alt=""
      />
      <div className={`${styles["app-page-content"]} ${className}`}>
        {children}
      </div>
      {bottomBar}
    </div>
  );
}

export default AppPage;
